/**
 * 瀑布流展示模式
 * 
 * 特点：
 * - 多列布局
 * - 高度自适应
 * - Pinterest风格
 * - 适合不同高度的内容
 */

import { MoreVertical } from 'lucide-react'
import { memo } from 'react'

import { getTextNotePlainText } from '@/modules/mine/text-content'
import type { Item } from '@/modules/mine/types'

interface ItemWaterfallProps {
  item: Item
}

export const ItemWaterfall = memo(({ item }: ItemWaterfallProps) => {
  const notePreview = item.format === 'text'
    ? getTextNotePlainText(item.note)
    : item.note

  return (
    <div className="group relative break-inside-avoid mb-4 rounded-xl border bg-card overflow-hidden hover:shadow-lg transition-all duration-200">
      {/* 图片：高度自适应 */}
      {item.website?.cover_url && (
        <div className="w-full overflow-hidden bg-muted">
          <img
            src={item.website?.cover_url}
            alt={item?.title}
            className="w-full object-cover group-hover:scale-105 transition-transform duration-200"
          />
        </div>
      )}

      {/* 内容区 */}
      <div className="p-4 space-y-2">
        {/* 标题：最多3行 */}
        <h3 className="font-medium text-sm leading-tight line-clamp-3">
          {item?.title}
        </h3>
        
        {/* 描述：最多2行 */}
        {notePreview && (
          <p className="text-xs text-muted-foreground line-clamp-2">
            {notePreview}
          </p>
        )}
        
        {/* 底部信息 */}
        <div className="flex items-center gap-2 text-xs text-muted-foreground pt-2">
          {item.website?.favicon_url && (
            <img src={item.website?.favicon_url } alt="" className="w-4 h-4 rounded" />
          )}
          <span className="truncate flex-1">{item?.url}</span>
        </div>
      </div>

      {/* 操作按钮：hover显示 */}
      <button className="absolute top-2 right-2 p-2 rounded-lg bg-background/80 backdrop-blur opacity-0 group-hover:opacity-100 transition-opacity">
        <MoreVertical className="w-4 h-4" />
      </button>
    </div>
  )
})
